import { render } from "./Summerten.vue?vue&type=template&id=6649b738"
import script from "./Summerten.vue?vue&type=script&lang=js"
export * from "./Summerten.vue?vue&type=script&lang=js"

import "./Summerten.vue?vue&type=style&index=0&id=6649b738&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__